import { systemUpdateFactory } from '@salsita-ai/platform-project-sdk/domain';
import { round } from '../util/round.js';
import { stackItemComponent } from './stack-component.js';
export class StackSystem {
    _context;
    constructor(_context){
        this._context = _context;
        this.fillStack = (options, fn, state)=>{
            const stack = [];
            const stackItemRecipes = [];
            const allOtherRecipes = [];
            const direction = options.from < options.to ? 'left' : 'right';
            if (direction === 'left') {
                let x = options.from;
                while(true){
                    const { width, stackItemRecipe, otherRecipes } = fn(x, stack.length);
                    // TODO: How to solve this globally?
                    // To prevent JS rounding errors.
                    const itemOffset = round(width + x, 2);
                    const wallEnd = round(options.to, 2);
                    if (itemOffset > wallEnd) {
                        break;
                    }
                    stack.push({
                        x
                    });
                    stackItemRecipes.push(stackItemRecipe);
                    allOtherRecipes.push(...otherRecipes);
                    x += width;
                }
            } else {
                let x = options.from;
                while(true){
                    const { width, stackItemRecipe, otherRecipes } = fn(x, stack.length);
                    // TODO: How to solve this globally?
                    // To prevent JS rounding errors.
                    const itemOffset = round(x - width, 2);
                    const wallEnd = round(options.to, 2);
                    if (itemOffset < wallEnd) {
                        break;
                    }
                    stack.push({
                        x: x - width
                    });
                    stackItemRecipes.push(stackItemRecipe);
                    allOtherRecipes.push(...otherRecipes);
                    x -= width;
                }
            }
            const createUpdates = this._context.recipeCooker.prepareCreateUpdates([
                ...stackItemRecipes,
                ...allOtherRecipes
            ], state, options.parentEntityId);
            const moveUpdates = stack.map((item, index)=>{
                const newId = createUpdates[index].entityId;
                return systemUpdateFactory.ComponentModification({
                    componentInstance: {
                        entityId: newId,
                        componentType: stackItemComponent,
                        instanceName: options.stackItemInstance
                    },
                    updateTag: 'fillStack',
                    writableState: {
                        x: item.x,
                        stackKey: options.stackKey
                    }
                });
            });
            return [
                ...createUpdates,
                ...moveUpdates
            ];
        };
    }
    fillStack;
}

//# sourceMappingURL=stack-system.js.map